/**
 * Formatowanie kwot pieniężnych. Kwoty krążą po aplikacji w najmniejszej
 * jednostce waluty (grosze, centy) - dokładnie tak, jak podaje je Paddle -
 * a waluta jest ZAWSZE osobnym polem obok kwoty.
 *
 * Nie zakładamy złotówek: w jednym drzewie zdarzeń potrafią leżeć obok siebie
 * wpłaty w EUR, PLN i USD, a sformatowanie dolarów jako „zł" to nie kosmetyka,
 * tylko fałszywa informacja o pieniądzach.
 */

/**
 * Kwota w najmniejszej jednostce waluty → tekst dla użytkownika
 * (np. 2000 + 'EUR' + 'pl' → „20,00 €"). Pusta waluta = pokazujemy samą
 * liczbę, bo zmyślanie waluty byłoby gorsze niż jej brak.
 *
 * Nie dzielimy na sztywno przez 100: jen, won i peso chilijskie nie mają
 * części ułamkowej, więc „1200" to ¥1200, a nie ¥12. Liczbę miejsc po
 * przecinku bierzemy z samego Intl, dzięki czemu działa to dla każdej waluty.
 */
export function formatMoney(cents: number | null | undefined,
    currency: string | null | undefined, lang: string): string {
    const minor = Math.round(Number(cents ?? 0));
    const code = (currency ?? '').toUpperCase();
    if (!/^[A-Z]{3}$/.test(code)) {
        return (minor / 100).toLocaleString(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    try {
        const format = new Intl.NumberFormat(lang, { style: 'currency', currency: code });
        const miejsca = format.resolvedOptions().maximumFractionDigits ?? 2;
        return format.format(minor / Math.pow(10, miejsca));
    } catch {
        // waluta spoza listy Intl - lepiej surowy kod niż wyjątek w szablonie
        return (minor / 100).toLocaleString(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            + ' ' + code;
    }
}
